<template>
	<div>
		<tab name="11">{{id}} {{activityName}}</tab>
		<template v-if="data && channelName == ''">
			<el-card v-if="thirdPercentData ">
				<div class="page-group-title">
					<span>推广模板</span>
				</div>
				<div v-if="thirdPercentData" class="page-list-box">
					<el-checkbox-group size="medium" v-model="thirdsTemps">
						<el-checkbox v-for="(v,i) in thirdPercentData" :key="i"
							:label="v.source">{{v.thirdName}}</el-checkbox>
					</el-checkbox-group>
				</div>
				<div class="MB20">					
					<div class="page-group-title">
						<span>选择模式</span>
					</div>
					<el-radio-group size="medium" v-model="isIncrement" class="MT15">
						<el-radio :label="1">增量模式（对选中的演出,增加选中的渠道）</el-radio>
						<el-radio :label="0">覆盖模式（按选中覆盖）</el-radio>
					</el-radio-group>
				</div>
				<template v-if="thirdsTemps.includes('damai')">
					<div class="page-group-title">
						<span>大麦专属海报&热门标记</span>
					</div>
					<div class="page-list-box">
						<el-table :data="thirdListDamai" border style="width: 100%"  size="small" stripe>
							<el-table-column label="渠道">大麦</el-table-column>
							<el-table-column prop="isHot" label="是否热门" width="150">
								<template slot-scope="scope">
									<el-radio-group v-model="scope.row.isHot" size="medium">
										<el-radio :label="1">是</el-radio>
										<el-radio :label="0">否</el-radio>
									</el-radio-group>
								</template>
							</el-table-column>
							<el-table-column prop="poster" label="海报">
								<template slot-scope="scope" v-if="scope.row.poster"><el-image
										:src="scope.row.poster | coverImage(60,60)" fit="cover"
										:preview-src-list="[scope.row.poster]"></el-image></template>
							</el-table-column>
							<el-table-column prop="poster" label="上传海报" width="150">
								<template slot-scope="scope">
									<p v-if="scope.row.poster">
										<el-button type="text" size="small" icon="el-icon-edit"
											@click="upload(scope.row)">编辑</el-button>
									</p>
									<p v-else>
										<el-button type="text" size="small" icon="el-icon-upload"
											@click="upload(scope.row)">上传</el-button>
									</p>
								</template>				
							</el-table-column>
						</el-table>
					</div>
				</template>
				<div>
					<el-button v-if="$utils.have('/activity/saveAndApplyThirdTemplate')" type="primary"
						@click="submitThirdAll(1)" :loading="thirdbtnLoading2" size="small">保存并应用所有场次</el-button>
					<el-button v-if="$utils.have('/activity/saveAndApplyThirdTemplate')" type="primary"
						@click="submitThirdAll(2)" :loading="thirdbtnLoading2" size="small">应用到巡演所有场次</el-button>
				</div>
			</el-card>
			<el-card class="MT20">
				<div class="page-group-title hand" @click="showMoreFun">
					<span>渠道场次推广</span>
					<span :class="['showMore', showMore ? 'el-icon-top': 'el-icon-bottom']">
						<span v-if="showMore">收起</span>
						<span v-else>展开</span>
					</span>
				</div>
				<div v-if="data && showMore" class="page-list-box">
					<el-table :data="data.sessionList" border style="width: 100%" v-loading="dataLoading" size="small"
						stripe>
						<el-table-column prop="sessionName" label="场次" width="150"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="totalAmount" label="演出时间" width="200">
							<template slot-scope="scope">
								<p v-if="scope.row.startTime">起：{{ scope.row.startTime }}</p>
								<p v-if="scope.row.startTime">止：{{ scope.row.startTime }}</p>
							</template>
						</el-table-column>
						<el-table-column prop="thirds" label="推广渠道">
							<template slot-scope="scope">
								<el-checkbox-group v-model="scope.row.thirds" size="medium"
									@change="setThird(scope.row)" :disabled="data.isSeat == 1 ? true : false">
									<el-checkbox v-for="(v,i) in thirdAccount" :key="i"
										:label="v.source">{{v.thirdName}}</el-checkbox>
								</el-checkbox-group>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-card>
			<el-card class="MT20">
				<div class="page-group-title MT20">
					<span>渠道专属演出海报&热门标记</span>
				</div>
				<div v-if="data" class="page-list-box">
					<el-table :data="thirdList" border style="width: 100%" v-loading="dataLoading" size="small" stripe>
						<el-table-column prop="thirdName" label="渠道" width="150"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="isHot" label="是否热门" width="150">
							<template slot-scope="scope">
								<el-radio-group v-model="scope.row.isHot" size="medium">
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</template>
						</el-table-column>
						<el-table-column prop="poster" label="海报">
							<template slot-scope="scope" v-if="scope.row.poster"><el-image
									:src="scope.row.poster | coverImage(60,60)" fit="cover"
									:preview-src-list="[scope.row.poster]"></el-image></template>
						</el-table-column>
						<el-table-column prop="poster" label="上传海报" width="150">
							<template slot-scope="scope">
								<p v-if="scope.row.poster">
									<el-button type="text" size="small" icon="el-icon-edit"
										@click="upload(scope.row)">编辑</el-button>
									<el-button type="text" size="small" icon="el-icon-delete" v-if="scope.row.poster"
										@click="del(scope.row.thirdName)">删除海报</el-button>
								</p>
								<p v-else>
									<el-button type="text" size="small" icon="el-icon-upload"
										@click="upload(scope.row)">上传</el-button>
								</p>
							</template>

						</el-table-column>
						<el-table-column label="票品销售时间">
							<template slot-scope="scope">
								<el-date-picker class="MT10" v-model="datetimerange" type="datetimerange"
									start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
									size="medium" unlink-panels v-if="scope.row.thirdName=='大麦'"></el-date-picker>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-card>
			<el-card class="MT20">
				<div class="page-group-title MT20">
					<span>渠道关联</span><small><span class="color-danger">（将为不同渠道单独创建的演出绑定到一起）</span></small>
				</div>
				<div>
					<el-input placeholder="输入需要绑定的演出ID" v-model="sActivityIds" class="MT10">
						<el-button slot="append" icon="el-icon-search" @click="searchActivity()">搜索演出</el-button>
					</el-input>
					<el-table class="MT10" :data="sActivityList" size="mini" border stripe v-loading="sActivityLoading">
						<el-table-column prop="id" label="演出ID" width="90"></el-table-column>
						<el-table-column prop="name" label="演出名称" show-overflow-tooltip></el-table-column>
						<el-table-column label="推送渠道">
							<template slot-scope="scope">
								{{ scope.row.thirdNameList.toString() }}
							</template>
						</el-table-column>
						<el-table-column label="操作" width="80">
							<template slot-scope="scope">
								<el-button type="text" @click="delActivity(scope.row.id)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-card>
			<div class="MT20">
				<el-button v-if="$utils.have('/activity/saveThird')" type="primary" @click="submitThird()"
					:loading="thirdbtnLoading">确认提交</el-button>

			</div>
			<upload-poster ref="UploadPoster"></upload-poster>
		</template>
		<div v-else class="noAction">
			云仓推送的演出,暂时不支持外部销售
		</div>
	</div>
</template>

<script>
	import Tab from '../components/tab';
	import UploadPoster from './components/upload-poster';
	import {
		fetchThirdAccount
	} from '@/assets/js/commonApi';
	export default {
		props: {
			id: {
				type: [Number, String],
				default: null,
			},
		},
		components: {
			Tab,
			UploadPoster
		},
		data() {
			return {
				redirect: this.$route.query.redirect || '/activityManage/activity/list',
				dataLoading: false,
				data: null,
				activityName: '',
				sessionIdNameList: [],
				thirdAccount: [],
				thirds: '',
				thirdList: [],
				thirdListDamai: [{
					isHot:'',
					poster:''
					}					
				],//单独大麦的
				thirdbtnLoading: false,

				sActivityIds: "",
				sActivityLoading: false,
				sActivityList: [],
				channelName: '',
				thirdPercentData: [],
				thirdsTemps: [], //推广模板
				thirdbtnLoading2: false,
				sessionThirdTemplateListVO: {
					activityIds: [],
					thirds: []
				},
				showMore: true,
				datetimerange: [],
				isIncrement:0
			}
		},
		mounted() {
			this.getData()
			this.getThirdPercent()
		},
		created() {
			this.getThirdAccount()
		},

		methods: {
			//获取第三方平台
			getThirdAccount() {
				fetchThirdAccount({
						isThird: 1
					})
					.then((res) => {
						const {
							state,
							result
						} = res.data;
						if (state == 1 && result) {
							this.thirdAccount = result.thirdAccounts || [];

						} else {
							// this.$message.error(msg || "请求失败");
						}
					})
			},
			//获取第三方平台带百分数的
			getThirdPercent() {
				this.dataLoading = true;
				this.$request({
						url: "/activity/listActivityThirdAccount",
						params: {
							activityId: this.id
						},
						method: "post",
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1) {
							this.thirdPercentData = result.thirdAccounts


						} else {
							this.$message.error(msg || "获取数据失败,请重试");
						}
					})
					.catch(() => {
						this.$message.error("获取数据失败,请重试");
					})
					.finally(() => {
						this.dataLoading = false;
					});
			},
			//搜索演出
			async searchActivity(callback) {
				if (this.sActivityIds) {
					this.sActivityLoading = true;

					this.sActivityIds = this.sActivityIds.replace(/，/g, ',');

					let _sActivityIds = this.sActivityIds.split(',');
					_sActivityIds.map((v, i) => _sActivityIds[i] = parseInt(v));

					const res = await this.$request({
						url: '/activity/activityIdNameList',
						method: 'post',
						data: _sActivityIds
					}).catch(() => {
						return {
							data: {
								state: '0',
								msg: '请求错误'
							}
						};
					}).finally(() => {
						this.sActivityLoading = false;
					});

					const {
						state,
						msg,
						result
					} = res.data;

					if (state != 1) {
						return this.$message.error(msg || '请求失败');

					} else {
						if (result && result.length > 0) {

							result.map(item => {
								if (!this.sActivityList.find(v => v.id == item.id)) {
									this.sActivityList.push(item)
								}
							})

							callback && callback();

						} else {
							this.$message.error(msg || '没有找到相关演出');
						}
					}
				}
			},
			showMoreFun() {
				this.showMore = this.showMore ? false : true
			},
			//删除演出
			delActivity(id) {
				this.sActivityList = this.sActivityList.filter(v => v.id != id);
			},
			//编辑事件
			upload(data,type) {
				this.$refs.UploadPoster.show(data,type);
			},
			
			//获取数据
			getData() {
				this.dataLoading = true;
				this.$request({
						url: "/activity/thirdList",
						params: {
							activityId: this.id
						},
						method: "post",
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1) {
							this.data = result;
							this.thirdList = result.thirdList
							this.activityName = result.activityName
							this.channelName = result.channelName ? result.channelName : ''
							this.data.sessionList.forEach(item => {
								item.thirds = item.thirds ? item.thirds : []
							})
							this.data.sessionList = JSON.parse(JSON.stringify(this.data.sessionList));

							if (this.data.activitySalesChannelGroupTO && this.data.activitySalesChannelGroupTO.length >
								0) {
								var _arr = []
								this.data.activitySalesChannelGroupTO.map(v => {
									_arr.push({
										id: v.activityId,
										name: v.title,
										thirdNameList: v.thirdName.split(',')
									})
								})

								this.sActivityList = _arr
							}
							// var _arr2 = []
							// this.data.thirdList.forEach(item => {							
							// 	_arr2.push(item.third)						   
							// })
							this.thirdsTemps = this.data && this.data.sessionThirdTemplateListVO && this.data
								.sessionThirdTemplateListVO.thirds ? this.data.sessionThirdTemplateListVO.thirds : [
									"baoma", "beizhan"
								],
							this.thirdList.forEach((tab, idx) => {
								if (tab.thirdName == '大麦' && tab.startTime && tab.endTime) {
									this.datetimerange = [tab.startTime, tab.endTime]
								}

							})
							if( this.data && this.data.sessionThirdTemplateListVO && this.data.sessionThirdTemplateListVO.thirds.includes('damai')){								
								this.$set(this.thirdListDamai[0], 'isHot', this.data.sessionThirdTemplateListVO.isHot);							 
								this.$set(this.thirdListDamai[0], 'poster', this.data.sessionThirdTemplateListVO.poster);
							}
							

						} else {
							this.$message.error(msg || "获取数据失败,请重试");
						}
					})
					.catch(() => {
						this.$message.error("获取数据失败,请重试");
					})
					.finally(() => {
						this.dataLoading = false;
					});
			},
			//返回
			goBack() {
				if (this.redirect) {
					this.$router.push({
						path: this.redirect,
					});
				} else {
					this.$router.go(-1);
				}
			},
			setThird(e) {
				var _arrs = []
				var sourceArr = []
				this.thirdAccount.map((accountItem, accountIndex) => {
					this.data.sessionList.map((sessionItem, sessionIndex) => {
						sessionItem.thirds.map((thirdsItem, thirdsIndex) => {
							if (thirdsItem == accountItem.source && sourceArr.indexOf(accountItem
									.source) == -1) {
								sourceArr.push(accountItem.source)

								var isHot = 0
								var poster = ""


								this.data.thirdList.map((thirdItem, thirdIndex) => {
									if (thirdItem.third == accountItem.source) {
										isHot = thirdItem.isHot
										poster = thirdItem.poster
									}

								})
								_arrs.push({
									thirdName: accountItem.thirdName,
									isHot: isHot,
									poster: poster,
									third: accountItem.source,
								})
							}
						})
					})
				})
				this.thirdList = _arrs

			},
			del(name) {
				this.$confirm('确认要删除海报吗？', '删除', {
					center: true,
				}).then(() => {
					this.thirdList.forEach((tab, idx) => {

						if (tab.thirdName == name) {
							tab.poster = ''
						}
					})
				}).catch(() => {

				})
			},
			submitThird() {
				
				this.thirdList.forEach((tab, idx) => {
					if (tab.thirdName == '大麦') {
						tab.startTime = this.datetimerange && this.datetimerange[0] ? this.datetimerange[0] : '';
						tab.endTime = this.datetimerange && this.datetimerange[1] ? this.datetimerange[1] : '';
					}
				})
				
				var _Isposter = 0;
				this.thirdList.forEach((item,index) => {
					if( item.poster == '' && item.thirdName == '大麦' ){
						_Isposter = 1
					}					
				})
				if( _Isposter == 1 ){
					return this.$message.error("大麦海报不能为空，请上传海报！")
				}
				
				this.data.thirdList = this.thirdList
				var _arr = []
				if (this.sActivityList && this.sActivityList.length > 0) {
					this.sActivityList.map(v => {
						_arr.push({
							activityId: v.id,
							title: v.name,
							thirdName: v.thirdNameList.toString()
						})
					})
				}
				this.data.activitySalesChannelGroupTO = _arr
				this.thirdbtnLoading = true
				this.$request({
						url: "/activity/saveThird",
						method: "post",
						data: {
							...this.data
						},
					})
					.then((res) => {
						//处理成功回调
						const {
							state,
							msg
						} = res.data;
						if (state && state == 1) {
							this.$message.success('操作成功');
							this.getData()
							this.sActivityIds = ''

						} else {
							return this.$message.error(msg || "操作失败");
						}
					})
					.finally(() => {
						this.thirdbtnLoading = false;
					});

			},
			submitThirdAll(type) {				
				if (this.thirdsTemps.length === 0) {
					return this.$message.error("请先选择渠道模板")
				}
				
				var _Isposter = 0;				
				this.thirdListDamai.forEach((item,index) => {
					if( item.poster == '' && this.thirdsTemps.includes('damai')  ){
						_Isposter = 1
					}					
				})
				if( _Isposter == 1 ){
					return this.$message.error("大麦海报不能为空，请上传海报！")
				}
				
				if( this.thirdListDamai[0].isHot === '' && this.thirdsTemps.includes('damai') ){
					return this.$message.error("请选择是否热门！")
				}
				if( this.thirdsTemps.includes('damai') ){
					var _daMaiActivityPoster = []
						_daMaiActivityPoster.push({
							id:this.id,
							name:this.thirdListDamai[0].poster,
							isHot:this.thirdListDamai[0].isHot
						})
				}			
				
				this.$confirm('确定要保存推广模板，并应用到该演出下所有场次吗？', '应用推广模板', {}).then(() => {
					this.thirdbtnLoading2 = true
					this.sessionThirdTemplateListVO.activityIds = [this.id]
					this.sessionThirdTemplateListVO.thirds = this.thirdsTemps
					this.sessionThirdTemplateListVO.isIncrement = this.isIncrement
					this.sessionThirdTemplateListVO.settingType = type
					this.sessionThirdTemplateListVO.daMaiActivityPoster = _daMaiActivityPoster ? _daMaiActivityPoster : []
					
					this.$request({
							url: "/activity/saveAndApplyThirdTemplate",
							method: "post",
							data: {
								sessionThirdTemplateListVO: this.sessionThirdTemplateListVO
							},
						})
						.then((res) => {
							//处理成功回调
							const {
								state,
								msg
							} = res.data;
							if (state && state == 1) {
								this.$message.success('操作成功');								
								window.location.reload()

							} else {
								return this.$message.error(msg || "操作失败");
							}
						})
						.finally(() => {
							this.thirdbtnLoading2 = false;
						});


				}).catch(() => {

				})
			}

		}

	}
</script>

<style lang="scss" scoped>
	.noAction {
		padding: 50px 0;
		text-align: center;
		font-size: 16px;
	}

	.showMore {
		color: #1fbb7d;
		font-size: 14px;
		cursor: pointer;
	}
</style>